// import React, { useState, useEffect } from "react";
// import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import { styled } from "@mui/material/styles";
// import { Button, TablePagination } from "@mui/material";
// import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import InputBase from "@mui/material/InputBase";
// import IconButton from "@mui/material/IconButton";
// import SearchIcon from "@mui/icons-material/Search";
// import InputLabel from "@mui/material/InputLabel";
// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import AddNewUser from "../AddNewUser";
// import Modal from "../Modal";
// import Toast from "../../../utils/toast";
// import createInstance from "../../../api/axiosinstance";
// // import COLORS from "../../Themes/Colours.js"
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

// const aiDishaApi = createInstance("DISHA");

// const UserManagement = () => {
//   const [user_id, setUser_id] = useState("");
//   const [name, setName] = useState("");
//   const [users, setUsers] = useState([]);
//   const [gender, setGender] = useState("");
//   const [email, setEmail] = useState("");
//   const [mobile, setMobile] = useState("");
//   const [Date_of_birth, setDateOfBirth] = useState("");
//   const [address, setAddress] = useState("");
//   const [state, setState] = useState("");
//   const [city, setCity] = useState("");
//   const [role, setRole] = useState("");
//   const [status, setStatus] = useState("");
//   const [isEdit, setIsEdit] = useState(false);
//   const [data, setData] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [organization, setOrganization] = useState("");
//   const [accountsFilter, setAccountsFilter] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [userIdToChange, setUserIdToChange] = useState("");
//   const [actionType, setActionType] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedUserForEdit, setSelectedUserForEdit] = useState(null);
//   const { COLORS } = useThemeMode();

//   const fetchData = async () => {
//     try {
//       const response = await aiDishaApi.get(`/get-all-users`);
//       const data = response.data;
//       console.log("Fetched data from API:", data);
//       setData(data["All_users"]);
//     } catch (error) {
//       console.error("Error fetching user data:", error.message);
//       Toast.error("Failed to fetch user data");
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     if (data && data.length > 0) {
//       console.log("Data:", data);
//     }
//   }, [data]);

//   useEffect(() => {
//     if (
//       user_id === "Default" &&
//       name === "" &&
//       gender === "" &&
//       email === "" &&
//       mobile === "" &&
//       organization === "Upl Snipe" &&
//       Date_of_birth === "" &&
//       address === "" &&
//       state === "" &&
//       city === "" &&
//       role === "" &&
//       status === "InActive"
//     ) {
//       fetchData();
//       setPage(0);
//       setIsEdit(false);
//     }
//   }, [
//     user_id,
//     name,
//     gender,
//     email,
//     mobile,
//     organization,
//     Date_of_birth,
//     address,
//     state,
//     city,
//     role,
//     status,
//   ]);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleAddUserModalOpen = () => {
//     setIsEditMode(false);
//     setSelectedUserForEdit(null);
//     setIsAddUserModalOpen(true);
//   };

//   const handleAddUserModalClose = (newUser) => {
//     setIsAddUserModalOpen(false);
//     setIsEditMode(false);
//     setSelectedUserForEdit(null);
//     if (newUser) {
//       setUsers([...users, newUser]);
//     }
//   };

//   const handleEditUserModalOpen = (user) => {
//     console.log("Opening edit modal for user:", user);
//     setSelectedUserForEdit(user);
//     setIsEditMode(true);
//     setIsAddUserModalOpen(true);
//   };

//   const handleSearch = (event) => {
//     setSearchTerm(event.target.value);
//     setPage(0);
//   };

//   const handleAccountsFilterChange = (event) => {
//     setAccountsFilter(event.target.value);
//     setPage(0);
//   };

//   const filteredData = data.filter((user) => {
//     const userName = user.name || "";
//     const searchMatch = userName.toLowerCase().includes(searchTerm.toLowerCase());
//     let accountsMatch = true;

//     if (accountsFilter === "active") {
//       accountsMatch = user.status === "Active";
//     } else if (accountsFilter === "inactive") {
//       accountsMatch = user.status === "InActive";
//     }

//     console.log(`User ${user.user_id}: searchMatch=${searchMatch}, accountsMatch=${accountsMatch}`);
//     return searchMatch && accountsMatch;
//   });

//   const paginatedFilteredData = filteredData.slice(
//     page * rowsPerPage,
//     page * rowsPerPage + rowsPerPage
//   );

//   const userHeader = [
//     "User_id",
//     "Name",
//     "Email",
//     "Mobile",
//     "Address",
//     "Organization",
//     "Gender",
//     "State",
//     "City",
//     "Role",
//     "Status",
//     "Actions",
//   ];

//   const handleModalOpen = (userId, currentStatus) => {
//     console.log("Checking status:", userId, currentStatus);
//     setUserIdToChange(userId);
//     setSelectedStatus(currentStatus);
//     setActionType(currentStatus === "Active" ? "Deactivate" : "Activate");
//     setIsModalOpen(true);
//   };

//   const handleModalClose = () => {
//     setIsModalOpen(false);
//   };

//   const handleConfirm = async () => {
//     await handleActivateDeactivateUser(userIdToChange, selectedStatus);
//     setIsModalOpen(false);
//   };

//   const handleActivateDeactivateUser = async (userId, currentStatus) => {
//     try {
//       const newStatus = currentStatus === "Active" ? "InActive" : "Active";
//       console.log("Updating status for user:", userId, newStatus);
//       const response = await aiDishaApi.patch(`/update-status?user_id=${userId}&status=${newStatus}`);
//       if (response.status === 200) {
//         Toast.success(`User ${newStatus === "Active" ? "activated" : "deactivated"} successfully`);
//         fetchData();
//       }
//     } catch (error) {
//       console.error("Error updating user status:", error);
//       Toast.error("Failed to update user status");
//     }
//   };

//   const CssFormControl = styled(FormControl)({
//     "& label": {
//       color: "#033538",
//       "&.Mui-focused": {
//         color: "#033538",
//       },
//     },
//     "& .MuiInputBase-root": {
//       color: "#033538",
//       "& .MuiOutlinedInput-notchedOutline": {
//         borderColor: "#033538",
//         borderRadius: 10,
//       },
//       "&:hover .MuiOutlinedInput-notchedOutline": {
//         borderColor: "#033538",
//       },
//       "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//         borderColor: "#033538",
//       },
//     },
//   });

//   const CssSelect = styled(Select)({
//     "& .MuiSvgIcon-root": {
//       color: "#033538",
//       textAlign: "center",
//     },
//   });

//   return (
//     <div
//       style={{
//         height: "calc(100% - 6%)",
//         overflow: "scroll",
//         scrollbarWidth: "thin",
//         msOverflowStyle: "none",
//       }}
//     >
//       <Box
//         display="grid"
//         gridTemplateColumns="repeat(12, 1fr)"
//         sx={{
//           marginTop: "auto",
//           alignItems: "center",
//           borderRadius: "10px",
//           padding: "5% 1% 0% 1%",
//         }}
//       >
//         <Box
//           gridColumn="span 12"
//           sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
//         >
//           <Paper
//             sx={{
//               p: "2px 4px",
//               display: "flex",
//               width: "75%",
//               borderRadius: 2,
//               background: COLORS.primary,
//             }}
//           >
//             <IconButton
//               type="button"
//               sx={{ p: "8px", color: COLORS.text }}
//               aria-label="search"
//             >
//               <SearchIcon />
//             </IconButton>
//             <InputBase
//               sx={{ ml: 1, flex: 1, 
//                 fontFamily: "Poppins", 
//                 color: COLORS.text,
//                 "& input::placeholder": {
//                    color: `${COLORS.text} !important`, // 👈 placeholder color
//                    opacity: 10, // important (MUI reduces opacity by default)
//                  },
//                  }}
//               placeholder="Search by User Name"
//               inputProps={{ "aria-label": "search google maps" }}
//               value={searchTerm}
//               onChange={handleSearch}
//             />
//           </Paper>
//         </Box>

//         <Box gridColumn="span 1" sx={{ marginTop: "auto", textAlign: "left" }}>
//           <Typography
//             display="block"
//             gutterBottom
//             sx={{ color: COLORS.text, fontFamily: "poppins" }}
//           >
//             Filter by:
//           </Typography>
//         </Box>

//         <Box gridColumn="span 3" sx={{ marginTop: "auto", textAlign: "left" }}>
//           <CssFormControl sx={{ width: "95%", color:COLORS.text}}>
//             <InputLabel>Accounts</InputLabel>
//               <CssSelect
//                 label="Accounts"
//                 id="accounts-filter"
//                 size="small"
//                 value={accountsFilter}
//                 onChange={handleAccountsFilterChange}
//                 sx={{ width: "100%", 
//                   textAlign: "center",
//                  }}
//               >
//                 <MenuItem value="" sx={{ color: COLORS.text }}>
//                   All Accounts
//                 </MenuItem>
//                 <MenuItem value="active" sx={{ color: COLORS.text }}>
//                   Active Accounts
//                 </MenuItem>
//                 <MenuItem value="inactive" sx={{ color: COLORS.text }}>
//                   Inactive Accounts
//                 </MenuItem>
//               </CssSelect>
//             </CssFormControl>
//           </Box>

//         <Box gridColumn="span 4" sx={{ marginTop: "auto", marginLeft: "30%" }}>
//           <Button
//             variant="contained"
//             sx={{
//               background: COLORS.button,
//               "&:hover":{
//                 background:COLORS.hover_btn
//               },
//               marginRight: "10px",
//               color: COLORS.background,
//               fontFamily: "poppins",
//             }}
//             onClick={handleAddUserModalOpen}
//           >
//             Add New User
//           </Button>
//         </Box>
//       </Box>

//       <Box xs={1} sx={{  width: "100%", paddingLeft: "16px", paddingRight: "16px"}}>
//         <Grid container spacing={1} sx={{ justifyContent: "flex-start" }}>
//           <Grid item xs={12}>
//             <TableContainer
//               component={Paper}
//               sx={{
//                 marginTop: "25px",
//                 borderRadius: "10px",
//                 width:"100%",
//                 // marginLeft: "-55px",
//               }}
//             >
//               <Table size="small"  >
//                 <TableHead sx={{ background: COLORS.primary }}>
//                   <TableRow>
//                     {userHeader.map((header, index) => (
//                       <TableCell
//                         key={index}
//                         sx={{ color: COLORS.text, borderBottom: 0 }}
//                       >
//                         {header}
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody sx={{ background: COLORS.background }}>
//                   {Array.isArray(filteredData) && filteredData.length > 0 ? (
//                     paginatedFilteredData.map((user, index) => (
//                       <TableRow key={index}>
//                         {userHeader.slice(0, -1).map((header, headerIndex) => (
//                           <TableCell
//                             key={headerIndex}
//                             sx={{ color: COLORS.text, border: COLORS.secondary }}
//                           >
//                             {header === "Date_of_birth" &&
//                             user[header.toLowerCase().replace(" ", "_")]
//                               ? new Date(
//                                   user[header.toLowerCase().replace(" ", "_")]
//                                 ).toLocaleDateString()
//                               : user[header.toLowerCase().replace(" ", "_")]}
//                           </TableCell>
//                         ))}
//                         <TableCell
//                           sx={{
//                             color : COLORS.text, border: COLORS.secondary,
//                             minWidth: "200px",
//                           }}
//                         >
//                           <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
//                             <Button
//                               variant="contained"
//                               sx={{
//                                 background: COLORS.button_edit_bg,
//                                 "&:hover": {
//                                   background: COLORS.hover_edit_btn,
//                                 },
//                                 color: COLORS.background,
//                                 fontFamily: "poppins",
//                                 height: "24px",
//                                 padding: "2px 8px",
//                                 minWidth: "70px",
//                                 fontSize: "0.75rem",
//                                 "&:hover": {
//                                   backgroundColor: "#1976d2",
//                                 },
//                               }}
//                               onClick={() => handleEditUserModalOpen(user)}
//                             >
//                               Edit
//                             </Button>
//                             <Button
//                               variant="contained"
//                               sx={{
//                                 backgroundColor:
//                                   user.status === "Active" ? COLORS.button_red_bg : COLORS.button_green_bg,
//                                 color: COLORS.text,
//                                 fontFamily: "poppins",
//                                 height: "24px",
//                                 padding: "2px 8px",
//                                 minWidth: "90px",
//                                 fontSize: "0.75rem",
//                                 "&:hover": {
//                                   backgroundColor:
//                                     user.status === "Active" ?COLORS.hover_red_btn      // hover when Active (Deactivate button)
//                                         : COLORS.hover_green_btn,   // hover when Inactive (Activate button)
//                                   },
//                               }}
//                               onClick={() => handleModalOpen(user.user_id, user.status)}
//                             >
//                               {user.status === "Active" ? "Deactivate" : "Activate"}
//                             </Button>
//                           </Box>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   ) : (
//                     <TableRow>
//                       <TableCell
//                         colSpan={userHeader.length}
//                         sx={{ textAlign: "center", color: COLORS.text }}
//                       >
//                         No Data Available
//                       </TableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <TablePagination
//               component="div"
//               count={filteredData.length}
//               page={page}
//               onPageChange={handleChangePage}
//               rowsPerPage={rowsPerPage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//               rowsPerPageOptions={[5, 10, 25]}
//               sx={{
//                 background: COLORS.primary,
//                 color: COLORS.text,
//                 // marginLeft: "-55px",
//                 width: "100%",
//                 borderRadius: "0 0 10px 10px",
//               }}
//             />
//           </Grid>
//         </Grid>
//       </Box>

//       <AddNewUser
//         isOpen={isAddUserModalOpen}
//         onClose={handleAddUserModalClose}
//         fetchUserData={fetchData}
//         editUser={selectedUserForEdit}
//         isEditMode={isEditMode}
//       />

//       <Modal
//         isOpen={isModalOpen}
//         onClose={handleModalClose}
//         title="User Status"
//         action={handleConfirm}
//         actionType={actionType}
//       >
//         <Typography>
//           Are you sure you want to {actionType.toLowerCase()} this user?
//         </Typography>
//       </Modal>
//     </div>
//   );
// };

// export default UserManagement;



































import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { Button, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AddNewUser from "../AddNewUser";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import createInstance from "../../../api/axiosinstance";
// import COLORS from "../../Themes/Colours.js"
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const aiDishaApi = createInstance("DISHA");

// ✅ FIXED: Styled components without hardcoded colors
const CssFormControl = styled(FormControl)({
  "& .MuiOutlinedInput-root": {
    borderRadius: 10,
  },
});

const CssSelect = styled(Select)({
  // All styles via sx prop and MenuProps
});

const UserManagement = () => {
  const [user_id, setUser_id] = useState("");
  const [name, setName] = useState("");
  const [users, setUsers] = useState([]);
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [Date_of_birth, setDateOfBirth] = useState("");
  const [address, setAddress] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [organization, setOrganization] = useState("");
  const [accountsFilter, setAccountsFilter] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userIdToChange, setUserIdToChange] = useState("");
  const [actionType, setActionType] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedUserForEdit, setSelectedUserForEdit] = useState(null);
  const { COLORS } = useThemeMode();

  const fetchData = async () => {
    try {
      const response = await aiDishaApi.get(`/get-all-users`);
      const data = response.data;
      console.log("Fetched data from API:", data);
      setData(data["All_users"]);
    } catch (error) {
      console.error("Error fetching user data:", error.message);
      Toast.error("Failed to fetch user data");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      console.log("Data:", data);
    }
  }, [data]);

  useEffect(() => {
    if (
      user_id === "Default" &&
      name === "" &&
      gender === "" &&
      email === "" &&
      mobile === "" &&
      organization === "Upl Snipe" &&
      Date_of_birth === "" &&
      address === "" &&
      state === "" &&
      city === "" &&
      role === "" &&
      status === "InActive"
    ) {
      fetchData();
      setPage(0);
      setIsEdit(false);
    }
  }, [
    user_id,
    name,
    gender,
    email,
    mobile,
    organization,
    Date_of_birth,
    address,
    state,
    city,
    role,
    status,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAddUserModalOpen = () => {
    setIsEditMode(false);
    setSelectedUserForEdit(null);
    setIsAddUserModalOpen(true);
  };

  const handleAddUserModalClose = (newUser) => {
    setIsAddUserModalOpen(false);
    setIsEditMode(false);
    setSelectedUserForEdit(null);
    if (newUser) {
      setUsers([...users, newUser]);
    }
  };

  const handleEditUserModalOpen = (user) => {
    console.log("Opening edit modal for user:", user);
    setSelectedUserForEdit(user);
    setIsEditMode(true);
    setIsAddUserModalOpen(true);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };

  const handleAccountsFilterChange = (event) => {
    setAccountsFilter(event.target.value);
    setPage(0);
  };

  const filteredData = data.filter((user) => {
    const userName = user.name || "";
    const searchMatch = userName.toLowerCase().includes(searchTerm.trim().toLowerCase());
    let accountsMatch = true;

    if (accountsFilter === "active") {
      accountsMatch = user.status === "Active";
    } else if (accountsFilter === "inactive") {
      accountsMatch = user.status === "InActive";
    }

    return searchMatch && accountsMatch;
  });

  const paginatedFilteredData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const userHeader = [
    "User_id",
    "Name",
    "Email",
    "Mobile",
    "Address",
    "Organization",
    "Gender",
    "State",
    "City",
    "Role",
    "Status",
    "Actions",
  ];

  const handleModalOpen = (userId, currentStatus) => {
    console.log("Checking status:", userId, currentStatus);
    setUserIdToChange(userId);
    setSelectedStatus(currentStatus);
    setActionType(currentStatus === "Active" ? "Deactivate" : "Activate");
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleConfirm = async () => {
    await handleActivateDeactivateUser(userIdToChange, selectedStatus);
    setIsModalOpen(false);
  };

  const handleActivateDeactivateUser = async (userId, currentStatus) => {
    try {
      const newStatus = currentStatus === "Active" ? "InActive" : "Active";
      console.log("Updating status for user:", userId, newStatus);
      const response = await aiDishaApi.patch(`/update-status?user_id=${userId}&status=${newStatus}`);
      if (response.status === 200) {
        Toast.success(`User ${newStatus === "Active" ? "activated" : "deactivated"} successfully`);
        fetchData();
      }
    } catch (error) {
      console.error("Error updating user status:", error);
      Toast.error("Failed to update user status");
    }
  };

  return (
    <div
      style={{
        height: "calc(100% - 6%)",
        overflow: "scroll",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
      }}
    >
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "5% 1% 0% 1%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Paper
            sx={{
              p: "2px 4px",
              display: "flex",
              width: "75%",
              borderRadius: 2,
              background: COLORS.primary,
            }}
          >
            <IconButton
              type="button"
              sx={{ p: "8px", color: COLORS.text }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{ 
                ml: 1, 
                flex: 1, 
                fontFamily: "Poppins", 
                color: COLORS.text,
                "& input::placeholder": {
                  color: `${COLORS.text} !important`,
                  opacity: 10,
                },
              }}
              placeholder="Search by User Name"
              inputProps={{ "aria-label": "search google maps" }}
              value={searchTerm}
              onChange={handleSearch}
            />
          </Paper>
        </Box>

        <Box gridColumn="span 1" sx={{ marginTop: "auto", textAlign: "left" }}>
          <Typography
            display="block"
            gutterBottom
            sx={{ color: COLORS.text, fontFamily: "poppins" }}
          >
            Filter by:
          </Typography>
        </Box>

        {/* ✅ FIXED: Complete dropdown styling with MenuProps */}
        <Box gridColumn="span 3" sx={{ marginTop: "auto", textAlign: "left" }}>
          <CssFormControl 
            sx={{ 
              width: "95%",
              // ✅ All COLORS styling via sx prop
              "& label": { 
                color: COLORS.text,
              },
              "& label.Mui-focused": { 
                color: COLORS.text,
              },
              "& .MuiInputBase-root": {
                color: COLORS.text,
                backgroundColor: COLORS.primary,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: COLORS.border,
                  borderRadius: 10,
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: COLORS.border,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: COLORS.border,
                },
              },
              "& .MuiSvgIcon-root": { 
                color: COLORS.text,
              },
            }}
          >
            <InputLabel sx={{ color: COLORS.text }}>Accounts</InputLabel>
            <CssSelect
              label="Accounts"
              id="accounts-filter"
              size="small"
              value={accountsFilter}
              onChange={handleAccountsFilterChange}
              sx={{ 
                width: "100%", 
                textAlign: "center",
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    // ✅ CRITICAL: Style the dropdown menu container
                    backgroundColor: COLORS.primary,
                    color: COLORS.text,
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    // ✅ Style ALL MenuItems inside the dropdown
                    "& .MuiMenuItem-root": {
                      backgroundColor: COLORS.primary,
                      color: COLORS.text,
                      padding: "10px 16px",
                      "&:hover": {
                        backgroundColor: COLORS.hoverBg,
                      },
                      "&.Mui-selected": {
                        backgroundColor: COLORS.hoverBg,
                        color: COLORS.text,
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: COLORS.hoverBg,
                        color: COLORS.text,
                      },
                    },
                  },
                },
                // ✅ Additional props for menu positioning
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
              }}
            >
              <MenuItem 
                value="" 
                sx={{ 
                  color: COLORS.text,
                  backgroundColor: COLORS.primary,
                  "&:hover": {
                    backgroundColor: COLORS.hoverBg,
                  },
                  "&.Mui-selected": {
                    backgroundColor: COLORS.hoverBg,
                  },
                }}
              >
                All Accounts
              </MenuItem>
              <MenuItem 
                value="active" 
                sx={{ 
                  color: COLORS.text,
                  backgroundColor: COLORS.primary,
                  "&:hover": {
                    backgroundColor: COLORS.hoverBg,
                  },
                  "&.Mui-selected": {
                    backgroundColor: COLORS.hoverBg,
                  },
                }}
              >
                Active Accounts
              </MenuItem>
              <MenuItem 
                value="inactive" 
                sx={{ 
                  color: COLORS.text,
                  backgroundColor: COLORS.primary,
                  "&:hover": {
                    backgroundColor: COLORS.hoverBg,
                  },
                  "&.Mui-selected": {
                    backgroundColor: COLORS.hoverBg,
                  },
                }}
              >
                Inactive Accounts
              </MenuItem>
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box gridColumn="span 4" sx={{ marginTop: "auto", marginLeft: "30%" }}>
          <Button
            variant="contained"
            sx={{
              background: COLORS.button,
              "&:hover": {
                background: COLORS.hover_btn,
              },
              marginRight: "10px",
              color: COLORS.background,
              fontFamily: "poppins",
            }}
            onClick={handleAddUserModalOpen}
          >
            Add New User
          </Button>
        </Box>
      </Box>

      <Box xs={1} sx={{ width: "100%", paddingLeft: "16px", paddingRight: "16px" }}>
        <Grid container spacing={1} sx={{ justifyContent: "flex-start" }}>
          <Grid item xs={12}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
                width: "100%",
              }}
            >
              <Table size="small">
                <TableHead sx={{ background: COLORS.primary }}>
                  <TableRow>
                    {userHeader.map((header, index) => (
                      <TableCell
                        key={index}
                        sx={{ color: COLORS.text, borderBottom: 0 }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody sx={{ background: COLORS.background }}>
                  {Array.isArray(filteredData) && filteredData.length > 0 ? (
                    paginatedFilteredData.map((user, index) => (
                      <TableRow key={index}>
                        {userHeader.slice(0, -1).map((header, headerIndex) => (
                          <TableCell
                            key={headerIndex}
                            sx={{ color: COLORS.text, border: COLORS.secondary }}
                          >
                            {header === "Date_of_birth" &&
                            user[header.toLowerCase().replace(" ", "_")]
                              ? new Date(
                                  user[header.toLowerCase().replace(" ", "_")]
                                ).toLocaleDateString()
                              : user[header.toLowerCase().replace(" ", "_")]}
                          </TableCell>
                        ))}
                        <TableCell
                          sx={{
                            color: COLORS.text,
                            border: COLORS.secondary,
                            minWidth: "200px",
                          }}
                        >
                          <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                            <Button
                              variant="contained"
                              sx={{
                                background: COLORS.button_edit_bg,
                                "&:hover": {
                                  background: COLORS.hover_edit_btn,
                                },
                                color: COLORS.background,
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "70px",
                                fontSize: "0.75rem",
                              }}
                              onClick={() => handleEditUserModalOpen(user)}
                            >
                              Edit
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor:
                                  user.status === "Active"
                                    ? COLORS.button_red_bg
                                    : COLORS.button_green_bg,
                                color: COLORS.text,
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "90px",
                                fontSize: "0.75rem",
                                "&:hover": {
                                  backgroundColor:
                                    user.status === "Active"
                                      ? COLORS.hover_red_btn
                                      : COLORS.hover_green_btn,
                                },
                              }}
                              onClick={() => handleModalOpen(user.user_id, user.status)}
                            >
                              {user.status === "Active" ? "Deactivate" : "Activate"}
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={userHeader.length}
                        sx={{ textAlign: "center", color: COLORS.text }}
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={filteredData.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              sx={{
                background: COLORS.primary,
                color: COLORS.text,
                width: "100%",
                borderRadius: "0 0 10px 10px",
              }}
            />
          </Grid>
        </Grid>
      </Box>

      <AddNewUser
        isOpen={isAddUserModalOpen}
        onClose={handleAddUserModalClose}
        fetchUserData={fetchData}
        editUser={selectedUserForEdit}
        isEditMode={isEditMode}
      />

      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title="User Status"
        action={handleConfirm}
        actionType={actionType}
      >
        <Typography>
          Are you sure you want to {actionType.toLowerCase()} this user account?
          <br />
          {actionType === "Activate"
            ? "Once activated, the user will be able to sign in and access all features and permissions assigned to their role."
            : "Once deactivated, the user will no longer be able to sign in or access the application until the account is reactivated."}
        </Typography>
      </Modal>
    </div>
  );
};

export default UserManagement;